// extracted by mini-css-extract-plugin
export var modalFooter = "_s4-0";